import {
  ArdoqId,
  CopyAsyncBundleResponse,
  CopyBundleBody,
  CopyBundleResponse,
  CopyConfig,
  PersistedBundleShape,
  ValidateBundleResponse,
  ValidateCopyBundleBody,
  ValidateCopyBundleResponse,
} from '@ardoq/api-types';
import { Method, crudApi, fetchJson, toRequestOptions } from './api';
import { ApiResponse } from './types';

const copy = async (
  bundleId: ArdoqId,
  body: CopyBundleBody
): ApiResponse<CopyBundleResponse> => {
  const request = new Request(
    `/api/bundle/${bundleId}/copy`,
    toRequestOptions(Method.POST, body)
  );
  return fetchJson<CopyBundleResponse>(request);
};

const copyAsync = async (
  bundleId: ArdoqId,
  body: CopyBundleBody
): ApiResponse<CopyAsyncBundleResponse> => {
  const request = new Request(
    `/api/bundle/${bundleId}/copy-async`,
    toRequestOptions(Method.POST, body)
  );
  return fetchJson<CopyAsyncBundleResponse>(request);
};

const validateCopyConfig = async (
  copyConfig: CopyConfig
): ApiResponse<ValidateBundleResponse> => {
  const request = new Request(
    `/api/bundle/validate-copy-config`,
    toRequestOptions(Method.POST, copyConfig)
  );
  return fetchJson<ValidateBundleResponse>(request);
};

const validateCopy = async (
  bundleId: ArdoqId,
  body: ValidateCopyBundleBody
): ApiResponse<ValidateCopyBundleResponse> => {
  const request = new Request(
    `/api/bundle/${bundleId}/validate-copy`,
    toRequestOptions(Method.POST, body)
  );
  return fetchJson<ValidateCopyBundleResponse>(request);
};

export const bundleApi = {
  ...crudApi<PersistedBundleShape>('bundle'),
  copy,
  copyAsync,
  validateCopyConfig,
  validateCopy,
};
